import React, { useEffect, useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import styles from "./language.module.css";
import { LanguageApi } from "../../../../App/api/setting";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import { toast } from "react-toastify";
import ViewTranslation from "./ViewTranslation";
import { UsersApi } from "../../../../App/api/users.api";

const Language = ({ meta }) => {
  // Initial language
  const initialData = [
    {
      id: "1",
      name: "Sanskrit",
      code: "sk",
      value: "Value1",
      action: "Action",
    },
    { id: "2", name: "Hindi", code: "hn", value: "Value2", action: "Action" },
    { id: "3", name: "English", code: "en", value: "Value3", action: "Action" },
  ];

  const [data, setData] = useState(initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [langData, setLangData] = useState({});
  const [viewTranslation, setViewTranslation] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);

  // console.log("Selected role", selectedRole);
  const { value: userRole } = useFetchAll(() => UsersApi.getUserRole());

  // console.log("user role", userRole?.data);

  const [newLanguage, setNewLanguage] = useState({
    name: "",
    code: "",
    value: "",
  });
  const [editingLanguageId, setEditingLanguageId] = useState(null);

  const { value, fetchAllData } = useFetchAll(() =>
    LanguageApi.getAllLanguages()
  );

  const deleteLanguage = async (id) => {
    // console.log("delete lang id", id);

    try {
      await LanguageApi.deleteLanguage(id);
      toast.success("Delted language successfully");
      fetchAllData();
    } catch (error) {
      console.error("Failed to delete language:", error);
    }
  };

  //  function for open the modal
  const openModal = (rowData) => {
    setLangData(rowData);
    setEditingLanguageId(rowData?._id);
    // console.log("rowData", rowData, "id", rowData?._id);

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setNewLanguage({ name: "", code: "", value: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewLanguage((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addLanguage = async (langData) => {
    if (newLanguage.name && newLanguage.code && newLanguage.value) {
      // console.log(newLanguage);
      // console.log(editingLanguageId);
      try {
        if (editingLanguageId) {
          const res = await LanguageApi.updateLanguage(
            editingLanguageId,
            newLanguage
          );
          toast.success("Updated language successfull");
        } else {
          const res = await LanguageApi.createLanguage(newLanguage);
          // console.log("res", res);
          toast.success("Added language successfull");
        }
        // fetchLanguages();
        fetchAllData();
        closeModal();
      } catch (error) {
        console.error("Failed to save language:", error);
      }

      const newId = data.length + 1;
      const updatedData = [
        ...data,
        {
          id: newId.toString(),
          name: newLanguage.name,
          code: newLanguage.code,
          value: newLanguage.value,
          action: "Action",
        },
      ];
      // console.log("updatedData", updatedData);
      setData(updatedData); // Update the state with the new language
      setNewLanguage({ name: "", code: "", value: "" }); // Reset the input fields
      closeModal(); // Close the modal after adding
    }
  };
  const handleModalSubmit = (newKey) => {
    // Handle the new key submission
    // console.log("New key from modal:", newKey);
    // Optionally, update the state or send data to an API
  };
  // console.log("seelcted data", selectedRole);
  return (
    <>
      <CommonLayout />
      <div className={styles.card} style={{ margin: "1rem" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="flex gap-3 items-center ">
            <p style={{ margin: "1.6rem", fontSize: "1.4rem" }}>
              {viewTranslation ? "Translation view" : "Language List"}
            </p>
            {/* <select
              className="w-fit h-fit py-2 px-2 border rounded-md text-lg"
              name="user_role"
              id="user_role"
              defaultValue={() =>
                setSelectedRole(
                  userRole && userRole.data && userRole?.data[0]?._id
                )
              }
              value={selectedRole}
              onChange={(event) => setSelectedRole(event.target.value)}
            >
              {userRole?.data?.map((item) => (
                <option className="p-2 border border-red-500" value={item?._id}>
                  {item?.name}
                </option>
              ))}
            </select> */}
            {/* <button
              className="tex-base rounded-md bg-[#e34e4e]  p-2 text-white  round-md"
              onClick={() => setIsModalVisible(true)}
            >
              Add New Key
            </button> */}
          </div>
          {/* added button for adding language lists */}
          <div style={{ display: "flex", gap: "5px" }}>
            <span>
              {/* <button
                style={{
                  border: "1px solid var(--color--2)",
                  width: "fit-content",
                  paddingInline: ".5rem",
                  paddingBlock: ".5rem",
                  borderRadius: "1rem",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                {viewTranslation ? "View Languages" : "View Translation"}
              </button> */}
            </span>
            <span>
              <button
                onClick={openModal}
                style={{
                  border: "1px solid var(--color--2)",
                  width: "fit-content",
                  paddingInline: ".5rem",
                  paddingBlock: ".5rem",
                  borderRadius: "1rem",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Add Language
              </button>
            </span>
          </div>
        </div>
        {viewTranslation ? (
          <ViewTranslation
            data={value?.data}
            userRole={selectedRole}
            handleModalSubmit={handleModalSubmit}
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
          />
        ) : (
          <DataTable value={value?.data} tableStyle={{ minWidth: "50rem" }}>
            {[
             
              { field: "name", header: "Name" },
              { field: "code", header: "Code" },
              { field: "value", header: "Value" },
            ].map((col) => (
              <Column key={col.field} field={col.field} header={col.header} />
            ))}
            <Column
              field="Action"
              header="Action"
              body={(rowData) => (
                <div className="flex gap-2">
                  <button
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 transition"
                    onClick={() => openModal(rowData)}
                  >
                    Edit
                  </button>
                  <button
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition"
                    onClick={() => deleteLanguage(rowData._id)}
                  >
                    Delete
                  </button>
                </div>
              )}
            />
          </DataTable>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <h3 style={modalStyles.header}>Add Language</h3>
            <div style={modalStyles.inputContainer}>
              <input
                style={modalStyles.input}
                type="text"
                name="name"
                value={newLanguage.name}
                placeholder="Language Name"
                onChange={handleInputChange}
              />
              <input
                style={modalStyles.input}
                type="text"
                name="code"
                value={newLanguage.code}
                placeholder="Language Code"
                onChange={handleInputChange}
              />
              <input
                style={modalStyles.input}
                type="text"
                name="value"
                value={newLanguage.value}
                placeholder="Language Value"
                onChange={handleInputChange}
              />
            </div>
            <div style={modalStyles.buttonContainer}>
              <button onClick={closeModal} style={modalStyles.cancelButton}>
                Cancel
              </button>
              <button
                onClick={() => addLanguage(langData)}
                style={modalStyles.saveButton}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Basic styles for modal
const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "10px",
    minWidth: "400px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
  },
  header: {
    marginBottom: "20px",
    fontSize: "1.5rem",
    color: "#333",
    fontWeight: "bold",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginBottom: "20px",
  },
  input: {
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "1rem",
    width: "100%",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  cancelButton: {
    padding: "10px 20px",
    borderRadius: "5px",
    backgroundColor: "#ccc",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  saveButton: {
    padding: "10px 20px",
    borderRadius: "5px",
    backgroundColor: "#00365a",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
};

export default Language;
